// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "电机学",
      "tec": "宋泳达",
      "week": "1-8周",
      "add": "教学楼D座124新能"
    },
    {
      "sub": "机械设计基础",
      "tec": "鲍君善",
      "week": "1-8周",
      "add": "教学楼C座308教务"
    },
    {
      "sub": "风力发电原理",
      "tec": "关新",
      "week": "1-12周",
      "add": "教学楼B座221自控"
    },
    {
      "sub": "专业英语",
      "tec": "王帅杰",
      "week": "1-8周",
      "add": "教学楼B座221自控"
    },
    0
  ],
  "2": [
    {
      "sub": "太阳能光伏发电系统",
      "tec": "郭瑞",
      "week": "1-12周",
      "add": "教学楼C座303教务"
    },
    {
      "sub": "风电场电气系统",
      "tec": "于子淞陈琳",
      "week": "1-12周",
      "add": "教学楼C座303教务"
    },
    [
      {
        "sub": "太阳能热利用",
        "tec": "张宏丽",
        "week": "1-8周",
        "add": "教学楼C座112教务"
      },
      {
        "sub": "国家安全教育",
        "tec": "孙新",
        "week": "10,13-15周",
        "add": "教学楼A座119信息"
      }
    ],
    {
      "sub": "毛泽东思想和中国特色社会主义理论体系概论",
      "tec": "李芗霓",
      "week": "1-3,5,7-10周",
      "add": "图书馆1楼党史+网络数字教育基地"
    },
    0
  ],
  "3": [
    {
      "sub": "热工基础",
      "tec": "张霈雯",
      "week": "1-12周",
      "add": "教学楼B座321能动"
    },
    {
      "sub": "风力发电原理",
      "tec": "关新",
      "week": "1-12周",
      "add": "教学楼B座324能动"
    },
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "机械设计基础",
      "tec": "鲍君善",
      "week": "1-8周",
      "add": "教学楼C座112教务"
    },
    {
      "sub": "电机学",
      "tec": "宋泳达",
      "week": "1-8周",
      "add": "教学楼A座220电力"
    },
    {
      "sub": "风电场电气系统",
      "tec": "于子淞陈琳",
      "week": "1-12周",
      "add": "教学楼D座122新能"
    },
    {
      "sub": "太阳能光伏发电系统",
      "tec": "郭瑞",
      "week": "1-12周",
      "add": "教学楼A座127信息"
    },
    {
      "sub": "太阳能照明工程",
      "tec": "于子淞陈琳",
      "week": "5-12周",
      "add": "教学楼C座110教务"
    }
  ],
  "5": [
    {
      "sub": "毛泽东思想和中国特色社会主义理论体系概论",
      "tec": "李芗霓",
      "week": "1-3,5,7-10周",
      "add": "图书馆1楼党史+网络数字教育基地"
    },
    [
      {
        "sub": "工程伦理",
        "tec": "毛云秀王若曦",
        "week": "1-8周",
        "add": "教学楼C座112教务"
      },
      {
        "sub": "国家安全教育",
        "tec": "孙新",
        "week": "10,13-15周",
        "add": "教学楼A座421机械"
      }
    ],
    {
      "sub": "热工基础",
      "tec": "张霈雯",
      "week": "1-12周",
      "add": "教学楼B座321能动"
    },
    {
      "sub": "就业创业指导",
      "tec": "赵明明李瀚林",
      "week": "1-5周",
      "add": "教学楼C座212教务"
    },
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
